import { Link } from "react-router-dom";
import pages from "../content/pages.json";
import posts from "../content/posts.json";
import { PostGrid } from "../components/PostGrid";

// TODO for Dash: rewrite the intro below in your own words. The monogram is
// drawn with CSS, so there's no image to replace - but if you make a logo,
// drop it in src/images/ and swap the <div className="hero-mark"> for an <img>.
export const Home = () => (
  <>
    <section className="hero">
      <div className="hero-mark" aria-hidden="true">D</div>
      <h1>Hi, I'm Dash.</h1>
      <p className="lead">
        This is my corner of the internet - a place to put the things I make,
        play, and think about.
      </p>
      <p>
        I just built this site, so it's pretty empty right now. Check back and
        it will be filling up with whatever I'm into at the moment.
      </p>
    </section>

    <section>
      <h2 className="section-title">Explore</h2>
      <div className="topic-grid">
        {pages.map((page, i) => (
          <Link key={page.slug} to={`/${page.slug}`} className={`topic-card accent-${i % 4}`}>
            <h3>{page.title}</h3>
            <p>{page.tagline}</p>
          </Link>
        ))}
      </div>
    </section>

    <section>
      <h2 className="section-title">Latest from the blog</h2>
      <PostGrid posts={posts.slice(0, 3)} />
      <p className="see-all">
        <Link to="/blog">See all posts &rarr;</Link>
      </p>
    </section>
  </>
);
